import React, { useEffect } from "react";

import useLayoutStore from "stores/useLayoutStore";
import { ErrorDisplay } from "containers/Error/ErrorDisplay";
const ErrorDisplayPage = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <ErrorDisplay />
    </>
  );
};

export default ErrorDisplayPage;
